import React, { useEffect } from 'react';

import Markup from '../markup';
import useShareService from '../builder/hooks/useShareService';
import isEmpty from "lodash/isEmpty";
import { useHistory } from 'react-router-dom';

const ShareLoader = ({ setShareData, setManifest, shareData, setErrorState }) => {

  const { decode } = useShareService();
  const history = useHistory();

  const recoverData = ({ modelData, imagesData, membersData, manifest, version }) => {
    setShareData({
      modelData,
      imagesData,
      membersData,
      version
    });
    setManifest(manifest);
  };

  const showShareError = () => {
    setErrorState(true)
    history.push("/")
    setTimeout(() => setErrorState(false), 5000)
  }

  const decodeShareData = (encodedData) => {
   let result = decode(encodedData.replaceAll(' ', '+'))
   if(isEmpty(result)) throw "error" ;
   return result; 
  }


  const loadTeamImage = (model) => {
    if (!model?.teamImage || !model?.teamImage?.public_url) return Promise.resolve();

    return new Promise(resolve => {
      const image = new Image();
      image.addEventListener('load', () => {
        resolve(image);
        model.teamImage.image = image;
      });
      image.crossOrigin = 'anonymous';
      image.src = model?.teamImage?.public_url;
    });
  }

  const loadMouseImage = (model) => {
    if (!model?.image || !model?.image?.public_url) return Promise.resolve();

    return new Promise(resolve => {
      const image = new Image();
      image.addEventListener('load', () => {
        resolve(image);
        model.image.image = image;
      });
      image.crossOrigin = 'anonymous';
      image.src = model?.image?.public_url;
      image.alt = model?.image?.id;
    });
  }

  const loadSponsorImages = (model) => {
    if (!model?.sponsorImages) return Promise.resolve();

    const sides = Object.keys(model.sponsorImages);
    const promises = sides.map(side => {
      const sideItem = model.sponsorImages[side];
      return sideItem.map(fileItem => {
        if (fileItem === null || !fileItem?.public_url) return Promise.resolve();
        else {
          return new Promise(resolve => {
            const image = new Image();
            image.addEventListener('load', () => {
              resolve(image);
              fileItem.image = image;
            });
            image.crossOrigin = 'anonymous';
            image.src = fileItem.public_url;
          });
        }
      });
    });

    return Promise.all(promises);
  }

  const fetchLink = async (shareData:string) => {
    try{
      // Capture URL params IMMEDIATELY before any async work.
      // App.tsx's useEffect strips all query params via pushState(pathname),
      // so window.location.search will be empty by the time async callbacks run.
      const initialSearchParams:URLSearchParams = new URLSearchParams(window.location.search);
      const builderAction = initialSearchParams.get("builder_action");
      const projectId = initialSearchParams.get("project_id");
      const cartData = initialSearchParams.get("cart_data");

      const encodedLongLink = await window["getShareLink"](shareData)
      const decodedData = decodeShareData(encodedLongLink);
      Promise.all([
          loadSponsorImages(decodedData?.imagesData),
          loadTeamImage(decodedData?.imagesData),
          //mouse mat
          loadMouseImage(decodedData?.imagesData),
      ])
          .then(() => {
             // Use the params captured at the top (before async), not window.location.search
             decodedData.membersData.action = builderAction;
             decodedData.membersData.projectId = projectId;
             decodedData.membersData.cartData = cartData;
             decodedData.membersData.members.map(item =>{
               item.modelType = decodedData.modelType;
               item.messageBtn = 'Add item to cart';
               item.messageUnBtn = 'After adding this item to cart you will not be able to edit it again';
               item.resultAddedCart = false;
             });
             // Clean URL: remove share param, keep others
             initialSearchParams.delete("share");
             let paramsString = initialSearchParams.toString();
             let replaceUrl = window.location.origin + window.location.pathname + (paramsString ? `?${paramsString}` : "");
             window.history.replaceState({}, null, replaceUrl)
          })
          .then(() => recoverData(decodedData))
     } catch(e) {showShareError()}
  }

  useEffect(() => {
    shareData && fetchLink(shareData)
  }, [])

  return (
    <Markup.BaseLayout.BaseContainer>
      Loading...
    </Markup.BaseLayout.BaseContainer>
  );
}

export default React.memo(ShareLoader);
